import React from "react";
export default function WriteTool({ payload, result }) {
  const path = payload?.input?.file_path || "";
  const content = payload?.input?.content || "";
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>Wrote</h5>
        <pre className="tool-pre">{path}</pre>
      </div>
      <div className="tool-section">
        <h5>New content (input)</h5>
        <pre className="tool-pre">{content}</pre>
      </div>
      {result && result.is_error && (
        <div className="tool-section">
          <h5>Error</h5>
          <pre className="tool-pre">{result.content_preview}</pre>
        </div>
      )}
    </div>
  );
}
WriteTool.summarize = (p) => p?.input?.file_path || "";
